import { useEffect, useRef, useState } from "react";

import { Grid, Skeleton, useTheme } from "@mui/material";

import { request } from "@/Api";
import MarkdownRichEditor from "@/common/MarkdownRichEditor";

// TODO: make this component generic to an AiChatThread
export default function AiCanvas({
    threadId,
    canvasUpdate,
    newCanvasData,
    onLoad,
    onCreate,
    onUpdate,
    onChange,
    newLoadingState,
}) {
    // TODO: support edit without threadId dependency
    const [canvas, setCanvas] = useState(null);
    const [loading, setLoading] = useState(newLoadingState);
    const canvasRef = useRef(null);

    const canvasId = canvasUpdate?.id;

    const loadCanvas = () => {
        request.get(`/canvas/${canvasId}`).then((response) => {
            setCanvas(response.data);
            onLoad && onLoad(response.data);
        });
    };

    const updateCanvas = () => {
        request
            .patch(`/canvas/${canvasId}`, canvasRef.current)
            .then((response) => {
                onUpdate && onUpdate(response.data);
            });
    };

    const handleChange = (md) => {
        canvasRef.current = { ...canvasRef.current, content: md };
        onChange && onChange(md);
    };

    useEffect(() => {
        if (canvasId) {
            loadCanvas();
        } else {
            // Thread has no canvas — clear stale content
            setCanvas(null);
        }
    }, [canvasUpdate]);

    useEffect(() => {
        if (newCanvasData) {
            setCanvas({ ...canvas, content: newCanvasData });
        }
    }, [newCanvasData]);

    useEffect(() => {
        if (threadId) {
            setCanvas({ ...canvas, thread_id: threadId });
        }
    }, [threadId]);

    useEffect(() => {
        canvasRef.current = canvas;
    }, [canvas]);

    useEffect(() => {
        setLoading(newLoadingState);
    }, [newLoadingState]);

    return canvas ? (
        <Grid item height={"100%"} data-testid="ai-canvas-markdown-editor">
            <MarkdownRichEditor
                injectedMarkdown={canvas.content}
                onBlur={updateCanvas}
                onChange={handleChange}
            />
        </Grid>
    ) : loading ? (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                paddingRight: "12px",
            }}
        >
            <Skeleton
                variant="rectangular"
                width={"100%"}
                height={118}
                sx={{ borderRadius: 2 }}
            />
            <Skeleton
                variant="rectangular"
                width={"100%"}
                height={15}
                sx={{ borderRadius: 2, padding: 0, margin: 0 }}
            />
            {Array.from({ length: 10 }).map((_, index) => (
                <Skeleton
                    key={index}
                    variant="rectangular"
                    width={"100%"}
                    height={15}
                    sx={{ borderRadius: 2 }}
                />
            ))}
        </div>
    ) : null;
}
